<template>
  <label
    class="switch-label"
    ref="label"
    :class="{ 'switch-label--disabled': disabled }"
    @click.prevent
  >
    <input
      type="checkbox"
      class="switch-hidden"
      v-model="checked"
      :disabled="disabled"
    />
    <span class="switch"></span>
  </label>
</template>

<script>
export default {
  name: 'CiSwitch',
  props: {
    value: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: !!this.value,
    }
  },
  watch: {
    value(value) {
      this.checked = !!value
    },
  },
}
</script>
<style lang="scss" scoped>
$switch-trans: 0.3s ease;

.switch {
  display: block;
}

.switch-label {
  margin: 0;
  padding: 0;
  height: 35px;

  &.switch-label--disabled {
    pointer-events: none;
  }
}

.switch-hidden {
  position: absolute;
  left: -9999px;
}

input[type='checkbox'] ~ .switch {
  background-color: #9b9b9b;
  border-radius: 100px;
  border: 0.5px solid #d8d8d8;
  cursor: pointer;
  height: 35px;
  opacity: 0.5;
  outline: 0;
  position: relative;
  transition: background-color $switch-trans, opacity $switch-trans,
    box-shadow $switch-trans;
  width: 74px;
}

input[type='checkbox']:checked ~ .switch {
  background-color: $primary-green;
  opacity: 1;
  transition: background-color $switch-trans, opacity $switch-trans,
    box-shadow $switch-trans;
}

input[type='checkbox'] ~ .switch::after {
  top: 2px;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  content: '';
  height: 30px;
  left: 2px;
  position: absolute;
  transition: background-color $switch-trans, left $switch-trans,
    box-shadow $switch-trans;
  width: 30px;
}

input[type='checkbox']:checked ~ .switch::after {
  left: calc(100% - 32px);
  transition: left $switch-trans, background-color $switch-trans,
    box-shadow $switch-trans;
}
</style>
